import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

const HeaderFiltro: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        backgroundColor: '#F7941D',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 4,
        py: 3,
        overflow: 'hidden',
      }}
    >
      {!isMobile ? (
        <Box sx={{ p: 1, zIndex: 1, color: '#fff', maxWidth: 600 }}>
          <Typography variant="h3" fontWeight="bold" gutterBottom>
            Busque um Espaço
          </Typography>
          <Typography variant="subtitle2">
            Utilize os filtros abaixo para encontrar o espaço perfeito para o seu evento
          </Typography>
        </Box>
      ) : (
        <Box sx={{ p: 0, zIndex: 1, color: '#fff', textAlign: 'center' }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Busque um Espaço
          </Typography>
        </Box>
      )}
      {!isMobile && (
        <Box
          component="img"
          src="https://cedrom.com.br/wp-content/uploads/2023/06/espaco-1-1-1024x682.jpeg"
          alt="Banner"
          sx={{
            width: 600,
            position: isMobile ? 'relative' : 'absolute',
            top: isMobile ? 'auto' : 0,
            right: isMobile ? 'auto' : 0,
            height: isMobile ? 100 : '100%',
            objectFit: 'cover',
            zIndex: 0,
            boxShadow: '0px 0px 20px 0px #000000',
          }}
        />
      )}
    </Box>
  );
};

export default HeaderFiltro;
